/**
 * What each command prints when it actually finished.
 *
 * ## Why a marker is needed at all
 *
 * A run's terminal state comes from the ECS task's exit code, and the installer
 * **does not propagate Terraform's exit status** — it exits 0 after failing.
 * Measured on apply `rmtvk9nhf-3r1plh` (2026-09-10): the log carried
 * `Error: Kubernetes cluster unreachable`, the installer said it could not
 * verify the deployment, and `describe-tasks` still reported
 * `containers[0].exitCode: 0`. The run was therefore recorded `succeeded`, and
 * because deployments derive from runs, the console showed a **live** deployment
 * whose environment URL returned 503. That is IM-80.
 *
 * The root fix belongs to the image (MP-3569). What this side can do is refuse
 * to take the exit code as the whole story, and the cheapest honest corroboration
 * is the line the command prints when it genuinely completed.
 *
 * ## Why these exact strings
 *
 * The installer's own, observed in the run logs of 2026-09-10 — not paraphrased,
 * for the same reason `DEPLOYMENT_OUTPUT_FIELDS` uses the real `printf` labels: a
 * marker this side invents matches nothing and reports every run as broken.
 *
 * `output` looks for a banner label rather than a completion line because the
 * banner *is* that command's product; if it printed, the command worked. The
 * label survives redaction — only the value beside it is masked — which is what
 * lets the runner wrapper match on it after the redactor has run.
 *
 * ## Why this lives here and not with the nightly
 *
 * Two things consume it and they are not peers: the nightly exercise
 * (`shared/src/nightly/`) uses it to decide whether a step genuinely passed, and
 * the runner wrapper (`shared/src/bootstrap/runner-wrapper.ts`) interpolates it
 * into the shell that runs in a customer's account. A deployment wrapper
 * importing from a test harness would be the wrong way round, and two copies
 * would be two answers to one question.
 */
export const COMPLETION_MARKERS = {
    plan: 'Terraform plan completed.',
    apply: 'Apply complete!',
    output: 'Environment URL:',
    destroy: 'Destroy complete!',
};
//# sourceMappingURL=completion.js.map